import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import {
  GET_LOT_SIZING_CRITERIA_KEY,
  GET_LOT_SIZING_KEY,
  UPDATE_LOT_SIZING_CRITERIA_KEY,
} from '@/keys';
import type { LotSizingSizingMethod } from '@/types/core/lot-sizing/lot-sizing-sizing-method';

export type UpdateLotSizingCriteriaParams = {
  id: string;
  sizingMethod: LotSizingSizingMethod;
  containerId?: number | null;
  volumeTarget?: number | null;
};

const updateCriteria = async ({
  id,
  sizingMethod,
  containerId,
  volumeTarget,
}: UpdateLotSizingCriteriaParams): Promise<void> => {
  await api.put(`/lot-sizings/${id}/criteria`, {
    sizingMethod,
    containerId: containerId ?? null,
    volumeTarget,
  });
};

export const useUpdateCriteria = ({
  lotSizingId,
}: {
  lotSizingId: string;
}): UseMutationResult<void, Error, UpdateLotSizingCriteriaParams> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: UPDATE_LOT_SIZING_CRITERIA_KEY,
    mutationFn: updateCriteria,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...GET_LOT_SIZING_CRITERIA_KEY, lotSizingId],
      });
      queryClient.invalidateQueries({
        queryKey: [...GET_LOT_SIZING_KEY, lotSizingId],
      });
    },
  });
};
